
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/push-notifications",
      function () {
        return require("private-next-pages/admin/push-notifications.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/push-notifications"])
      });
    }
  